export default {
  loading: false,
  storeProfile: null,
  bannerList: [],
}
